import { Alert, Button, Col, Form, Input, message, Result, Row, Steps, Typography } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useStepsForm } from 'sunflower-antd';
import {  CheckOutlined, LoadingOutlined, RightOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from 'react-query';
import { errorMessage } from '../../common/errors';
import { DASHBOARD_SECTION_TITLES } from '../common/utils/styles';
import { useBreakpoint } from 'use-breakpoint';
import { Popup } from 'antd-mobile';

const { Step } = Steps;
const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 }


const FiscalKey: React.FC = () => {

  const queryClient = useQueryClient()
  const { breakpoint, maxWidth, minWidth } = useBreakpoint(BREAKPOINTS);
  const { t } = useTranslation()
  const baseUrl = process.env.REACT_APP_BASE_URL
  const token = JSON.parse(localStorage.getItem("token") || '{}')
  const config = {
    headers: {Authorization: `Bearer ${token}`}
  }

  const sendToken = () => {
    axios.patch(`${baseUrl}auth/request-change-fiscal-key`, {}, config)
  }

  const {
    form,
    current, 
    gotoStep,
    stepsProps,
    formProps,
    submit,
  } = useStepsForm({
    submit(values) {
      const {fiscalKey} = values
      onFinishForm(values)
    },
    total: 4,
  })

  const useSendForm = () => {
    return useMutation(async (values: any) => {
        return await axios.put(`${baseUrl}user/update-fiscal-key/`, values, config)
    },
    {
      onSuccess: (res) => {if (breakpoint === "mobile" || breakpoint === "tablet") {successMessageOnMobile(); setTimeout(() => {setPopupFiscalKeyVisible(false)}, 1500)} else {gotoStep(current + 1); queryClient.invalidateQueries({queryKey: ['userData']}); axios.get(`${baseUrl}user/me`, {headers: {Authorization: `Bearer ${token}`}}).then(res =>  {queryClient.setQueryData('userData', res.data)}); setTimeout(() => {gotoStep(0)}, 2000)}},
      onError: (e) => {gotoStep(0); errorMessage(t("dashboardPage.userSettings.fiscalKey.errorMessage")); setPopupFiscalKeyVisible(false)}
    })
  }

  const {mutate: onFinishForm} = useSendForm()

  const [messageApi, contextHolder] = message.useMessage();

  const successMessageOnMobile = () => {
    messageApi.open({
      type: 'success',
      icon: <CheckOutlined style={{color: "#03b9ac"}} />,
      content: t("dashboardPage.userSettings.fiscalKey.form.resultSuccessMessage")
    })
  }

  const tokenSentMessage = () => {
    messageApi.open({
      type: 'success',
      icon: <CheckOutlined style={{color: "#03b9ac"}} />,
      content: t("dashboardPage.userSettings.fiscalKey.form.successTokenSentMessage"),
      duration: 10,
    });
  };


  function hasFiscalKeyActions(){
    if (breakpoint === "desktop") {
      gotoStep(current + 1);
      sendToken()
      tokenSentMessage()
    }
    else {
      sendToken()
    }
    
  }

  const [userData, setUserData] = useState<any>()

  useEffect(() => {
    const userData: any = queryClient.getQueryData("userData")
    setUserData(userData)
  }, [current])


  const hasFiscalKey = () => {
    if (userData === undefined || userData.hasFiscalKey === undefined || userData.hasFiscalKey === null) return false
    else return true
  }

  const formList = [
    <>
        <Button onClick={() => {(hasFiscalKey()) ? hasFiscalKeyActions() : gotoStep(current + 2)}} id='btn-secondary'>{(hasFiscalKey()) ? t("dashboardPage.userSettings.fiscalKey.form.modifyButton") : t("dashboardPage.userSettings.fiscalKey.form.addButton")}</Button>  
    </>,
    <>
        <Row style={{display: "flex", justifyContent: "space-between"}}>
            <Col style={{gap: "20px"}} span={14}>
                <Form.Item name="token" label={t('dashboardPage.userSettings.fiscalKey.form.tokenLabel')}>
                    <Input placeholder={t('dashboardPage.userSettings.fiscalKey.form.inputTokenPlaceholder')||""} />
                </Form.Item>
            </Col>
            <Col style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}} span={9}>
                <Button onClick={() => {gotoStep(current + 1); }} id='btn-secondary'>{t("dashboardPage.userSettings.fiscalKey.form.nextStepButton")}</Button>
                <Button type='link' onClick={() => {sendToken(); tokenSentMessage()}} >{t("dashboardPage.userSettings.fiscalKey.form.sendTokenAgainButton")}</Button>
            </Col>
        </Row>
    </>,
    <>
        <Row style={{display: "flex", justifyContent: "space-between"}}>
            <Col style={{gap: "20px"}} span={15}>
        <Form.Item name="fiscalKey" label={t('dashboardPage.userSettings.fiscalKey.form.fiscalKeyLabel')}>
            <Input style={{maxHeight: "58px", lineHeight: "40px"}} placeholder={t('dashboardPage.userSettings.fiscalKey.form.inputFiscalKeyPlaceholder')||""}/>
        </Form.Item>
            </Col>
            <Col span={8}>
        <Button onClick={() => {submit()}} id='btn-secondary'>{t("dashboardPage.userSettings.fiscalKey.form.submitButton")}</Button>
            </Col>
        </Row>
    </>,
    <>
        <Row style={{display: "flex", justifyContent: "space-evenly"}}>
            <span style={{gap: "20px"}}>
            <CheckOutlined style={{color: "green", fontSize: "1.5rem", paddingLeft: "15px"}}/>
            {t("dashboardPage.userSettings.fiscalKey.form.resultSuccessMessage")}
            </span>
        </Row>
    </>
  ]

  const loadingIcon = <LoadingOutlined style={{ fontSize: 50, color: "#03b9ac" }} spin />;
  
  //Popup mobile
  const [popupFiscalKeyVisible, setPopupFiscalKeyVisible] = useState(false)

  //onChange token input mobile to display
  const [fiscalKeyInputHidden, setFiscalKeyInputHidden] = useState(true)
  const [tokenInputHidden, setTokenInputHidden] = useState(false)
  const [tokenValue, setTokenValue] = useState("")
  const isTokenFilled = (value: string) => {
    if (value.length > 2) setFiscalKeyInputHidden(false)
    else setFiscalKeyInputHidden(true)
  }

  return (
    <>
      {(breakpoint === "mobile" || breakpoint === "tablet") ?
      (userData === undefined) ?
      <div style={{display: 'flex', flexDirection: "row", alignContent: 'center', alignItems: "center"}}>{loadingIcon}</div>
      :
      <div style={{display: "flex"}}>
        {contextHolder}
        <Row onClick={() => {setPopupFiscalKeyVisible(true); form.resetFields(); if (hasFiscalKey()) hasFiscalKeyActions(); else {setTokenInputHidden(true); isTokenFilled("aaa")}}} style={{height: "135px",  justifyContent: "center",paddingLeft: "25px", width: "98vw", backgroundColor: "#F2F0F0", borderRadius: "4px", display: "flex", flexDirection: "row", alignItems: "center"}}>
          <Col span={22}>
          <>
            <Row>
              <Typography style={{fontWeight: "800", fontFamily: "Poppins"}}>{t("dashboardPage.userSettings.fiscalKey.title")}</Typography>
            </Row>
            <Row>
              <Typography style={{fontWeight: "500", fontFamily: "Poppins"}}>{t("dashboardPage.userSettings.fiscalKey.form.yourFiscalKeyIs")}</Typography><Typography style={{fontWeight: "300", fontFamily: "Poppins", paddingLeft: "5px"}}>{(hasFiscalKey()) ? "************" : t("dashboardPage.userSettings.fiscalKey.form.fiscalKeyNotFound")}</Typography>
            </Row>
          </>
          </Col>
          <Col span={2}>
            <RightOutlined />
          </Col>
        </Row>
        <Popup showCloseButton visible={popupFiscalKeyVisible} onMaskClick={() => {setPopupFiscalKeyVisible(false)}} onClose={() => setPopupFiscalKeyVisible(false)} bodyStyle={{ height: 'auto' }} mask={true} closeOnSwipe>
            <Row style={{display: "flex", flexDirection: "column",  justifyContent: "space-evenly", paddingLeft: "25px", paddingRight: "25px", paddingTop: "45px", paddingBottom: "25px", gap: "20px"}}>
                <Typography style={{fontFamily: "Poppins", fontSize: "15px", fontWeight: "800"}}>{t('dashboardPage.userSettings.fiscalKey.form.fiscalKeyLabel')}</Typography>
                <Row>
                  <Col hidden={!fiscalKeyInputHidden} span={24}>
                    <div style={{backgroundColor: "#69B2A8", color: "white", fontFamily: "Poppins", fontWeight: "600", borderRadius: "4px", textAlign: "center"}}>
                      {t('dashboardPage.userSettings.fiscalKey.form.successTokenSentMessage')}
                    </div>
                  </Col>
                </Row>
                <Form form={form} onFinish={useSendForm} style={{display: "flex", flexDirection: "column", gap: "15px"}}>
                  <Col span={24}>
                      <Form.Item shouldUpdate name="token" style={{marginBottom: "0px"}}>
                          <Input defaultValue={tokenValue} value={tokenValue} onChange={(e) => isTokenFilled(e.target.value)} style={{height: "38px"}} placeholder={t('dashboardPage.userSettings.fiscalKey.form.inputTokenPlaceholder')||""}/>
                      </Form.Item>
                  </Col>
                  <Col span={24}>
                      <Form.Item shouldUpdate hidden={fiscalKeyInputHidden} name="fiscalKey" style={{marginBottom: "0px"}}>
                          <Input style={{height: "38px"}} placeholder={t('dashboardPage.userSettings.fiscalKey.form.inputFiscalKeyPlaceholder')||""}/>
                      </Form.Item>
                  </Col>
                </Form>
                <Row style={{display: "flex", flexDirection: "row", gap: "10px", width: "100%", justifyContent: "space-between"}}>
                  <Col span={11}>
                    <Button style={{height: "38px", display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}} onClick={() => {sendToken(); isTokenFilled(""); setTokenValue("")}} id='btn-secondary-outline'>{t("dashboardPage.userSettings.fiscalKey.form.sendTokenAgainButton")}</Button>
                  </Col>
                  <Col span={11}>
                    <Button style={{height: "38px", display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}} onClick={() => {submit() }} id='btn-secondary'>{t("dashboardPage.userSettings.fiscalKey.form.submitButton")}</Button>
                  </Col>
                </Row>
            </Row>
        </Popup>
      </div>
      :
      <>
      {contextHolder}
      <Typography style={DASHBOARD_SECTION_TITLES} >{t("dashboardPage.userSettings.fiscalKey.title")}</Typography>
      <Steps>
      </Steps>
        <div>
          <Form name='fiscalKey' form={form} {...formProps}>
            {formList[current]}
          </Form>
        </div>
      </>
      }
    </>
  )
}

export default FiscalKey